import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormConfigModel } from '@shared/_models/Layout/FormConfig';
import { ObjectCreaterService } from '@services/objectCreation.service';


@Component({
    selector: 'app-jt-modal-hor-form',
    templateUrl: './app-modal-horizontal-form.component.html',
    styleUrls: ['./app-modal-horizontal-form.component.css'],
    standalone: false
})
export class AppModalHorizontalFormComponent implements OnInit {
  @Input() formConfig?: FormConfigModel;
  @Output() bySave = new EventEmitter();
  @Output() byCancel = new EventEmitter();

  constructor(private oc: ObjectCreaterService) {
    if (this.formConfig == undefined || this.formConfig == null) {
      this.formConfig = oc.CreateFormConfig();
    }
  }
  ngOnInit() {
    var ab = this.formConfig;
  }

  public Save() {
    this.bySave.emit();
  }

  public Cancel() {
    this.byCancel.emit();
  }
}
